export function firstIsVowel(string: string): boolean {
  if (!string || string.length < 1) {
    return false
  } else {
    return ['a', 'e', 'i', 'o', 'u'].indexOf(string[0].toLowerCase()) !== -1
  }
}
